window.initBtnRoll = function initBtnRoll() {
  const btns = document.querySelectorAll('[data-btn-roll]');

  btns.forEach((btn) => {
    if (btn.classList.contains('is-init-btn-roll')) return;
    btn.classList.add('is-init-btn-roll');

    const original = document.createElement('span');
    original.classList.add('btn__original');

    while (btn.firstChild) {
      original.appendChild(btn.firstChild);
    }

    const hover = original.cloneNode(true);
    hover.classList.remove('btn__original');
    hover.classList.add('btn__hover');
    hover.setAttribute('aria-hidden', 'true');

    btn.appendChild(original);
    btn.appendChild(hover);
  });
};

initBtnRoll();
